import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  anonymous: {
    id: 'studio.LXxsbk',
    defaultMessage: 'Anonymous',
  },
  ratings: {
    id: 'studio.XYovs/',
    defaultMessage: 'Ratings',
  },
  rateApp: {
    id: 'studio.n9fGMG',
    defaultMessage: 'Rate this app',
  },
  noRatings: {
    id: 'studio.Dqt5oO',
    defaultMessage: 'There are no ratings available yet. You can be the first to rate!',
  },
  loadingRatings: {
    id: 'studio.YAqTbk',
    defaultMessage: 'The ratings are being loaded',
  },
  average: {
    id: 'studio.nhkxb9',
    defaultMessage: '{average} out of 5',
  },
  ratingSuccessful: {
    id: 'studio.yCmZc8',
    defaultMessage: 'You successfully rated this app!',
  },
  you: {
    id: 'studio.bDz3Hi',
    defaultMessage: 'It’s you!',
  },
  loadError: {
    id: 'studio.QQLKiQ',
    defaultMessage: 'There was a problem loading app ratings.',
  },
  retry: {
    id: 'studio.62nsdy',
    defaultMessage: 'Retry',
  },
});
